var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51333 0H8.48667L12 3.51333V8.48667L8.48667 12H3.51333L0 8.48667V3.51333L3.51333 0ZM6.66671 2.66669H5.33337V7.33335H6.66671V2.66669ZM6.66671 8.66669C6.66671 9.03488 6.36823 9.33335 6.00004 9.33335C5.63185 9.33335 5.33337 9.03488 5.33337 8.66669C5.33337 8.2985 5.63185 8.00002 6.00004 8.00002C6.36823 8.00002 6.66671 8.2985 6.66671 8.66669Z",
    fill: "#DE1616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.eadb73d0d824cd29eb3a672b2f50c033.svg";
export { ForwardRef as ReactComponent };